module.exports = __webpack_public_path__ + "0bf93b16e5bd567d6fb00e536e6865cc.MP3";